import { render, staticRenderFns } from "./MarkDown.vue?vue&type=template&id=862c9cda&"
import script from "./MarkDown.vue?vue&type=script&lang=js&"
export * from "./MarkDown.vue?vue&type=script&lang=js&"
import style0 from "./MarkDown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports